import React, { useState, useEffect } from 'react';
import ContentHeader from '../../components/ContentHeader';
import Loader from "../../components/Loader";
import axios from "axios";
import $ from 'jquery';
import Swal from "sweetalert2";
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';

const DiscountCodes = () => {
    const [loading, setLoading] = useState(false);
    const [title, setTitle] = useState("Agregar Código de Descuento");
    const [discountCodeId, setDiscountCodeId] = useState(0);
    const [code, setCode] = useState('');
    const [discountPercentage, setDiscountPercentage] = useState('');
    const [validFrom, setValidFrom] = useState('');
    const [validUntil, setValidUntil] = useState('');
    const [maxUses, setMaxUses] = useState('');
    const [status, setStatus] = useState(1);
    const [discountCodes, setDiscountCodes] = useState([]);
    const ENDPOINT = process.env.REACT_APP_URL_ENDPOINT;
    const TITLEALERT = process.env.REACT_APP_TITLE_ALERT;

    useEffect(() => {
        getDiscountCodes();
        setTimeout(() => {
            $("#tableDiscountCodes").DataTable({
                language: {
                    url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
                },
                order: [[0, 'desc']],
                pageLength: 25
            });
        }, 500);
    }, []);

    const getDiscountCodes = async () => {
        try {
            setLoading(true);
            const response = await axios.get(ENDPOINT + 'discount-codes');
            if (response.data && Array.isArray(response.data)) {
                setDiscountCodes(response.data);
            } else if (response.data && Array.isArray(response.data.data)) {
                setDiscountCodes(response.data.data);
            } else {
                console.error('Formato de respuesta inesperado:', response.data);
                setDiscountCodes([]);
            }
            setLoading(false);
        } catch (error) {
            console.error('Error fetching discount codes:', error);
            setDiscountCodes([]);
            setLoading(false);
            Swal.fire({
                icon: 'error',
                title: TITLEALERT,
                text: 'Error al cargar los códigos de descuento',
            });
        }
    };

    const clearFields = () => {
        setDiscountCodeId(0);
        setCode('');
        setDiscountPercentage('');
        setValidFrom('');
        setValidUntil('');
        setMaxUses('');
        setStatus(1);
        setTitle("Agregar Código de Descuento");
    };

    const handleEdit = (discountCode) => {
        setDiscountCodeId(discountCode.discount_code_id);
        setCode(discountCode.code);
        setDiscountPercentage(discountCode.discount_percentage);
        setValidFrom(discountCode.valid_from.split('T')[0]);
        setValidUntil(discountCode.valid_until.split('T')[0]);
        setMaxUses(discountCode.max_uses);
        setStatus(discountCode.status);
        setTitle("Editar Código de Descuento");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            const data = {
                code,
                discount_percentage: discountPercentage,
                valid_from: validFrom,
                valid_until: validUntil,
                max_uses: maxUses,
                status
            };

            if (discountCodeId === 0) {
                await axios.post(ENDPOINT + 'discount-codes', data);
                Swal.fire({
                    icon: 'success',
                    title: TITLEALERT,
                    text: 'Código de descuento creado correctamente',
                    showConfirmButton: false,
                    timer: 1500
                });
            } else {
                await axios.put(ENDPOINT + 'discount-codes/' + discountCodeId, data);
                Swal.fire({
                    icon: 'success',
                    title: TITLEALERT,
                    text: 'Código de descuento actualizado correctamente',
                    showConfirmButton: false,
                    timer: 1500
                });
            }

            document.getElementById('closemodal').click();
            clearFields();
            $("#tableDiscountCodes").DataTable().destroy();
            await getDiscountCodes();
            setTimeout(() => {
                $("#tableDiscountCodes").DataTable({
                    language: {
                        url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
                    },
                    order: [[0, 'desc']],
                    pageLength: 25
                });
            }, 500);
            setLoading(false);
        } catch (error) {
            setLoading(false);
            Swal.fire({
                icon: 'error',
                title: TITLEALERT,
                text: error.response?.data?.message || 'Error al guardar el código de descuento',
            });
        }
    };

    const handleDelete = async (id) => {
        try {
            const result = await Swal.fire({
                title: '¿Estás seguro?',
                text: "¡No podrás revertir esto!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar'
            });

            if (result.isConfirmed) {
                setLoading(true);
                await axios.delete(ENDPOINT + 'discount-codes/' + id);
                $("#tableDiscountCodes").DataTable().destroy();
                await getDiscountCodes();
                setTimeout(() => {
                    $("#tableDiscountCodes").DataTable({
                        language: {
                            url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
                        },
                        order: [[0, 'desc']],
                        pageLength: 25
                    });
                }, 500);
                Swal.fire({
                    icon: 'success',
                    title: TITLEALERT,
                    text: 'Código de descuento eliminado correctamente',
                    showConfirmButton: false,
                    timer: 1500
                });
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            Swal.fire({
                icon: 'error',
                title: TITLEALERT,
                text: 'Error al eliminar el código de descuento',
            });
        }
    };

    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        const dia = date.getDate();
        const mes = date.toLocaleString('es-ES', { month: 'long' });
        const año = date.getFullYear();
        return `${dia} de ${mes} de ${año}`;
    };

    return (
        <>
            {loading && <Loader />}
            
            {/* Modal para agregar/editar */}
            <div className="modal fade" id="modal-default" aria-labelledby="modal-default" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header bg-header-modal">
                            <h4 className="modal-title">{title}</h4>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <form id="formulario" onSubmit={handleSubmit}>
                            <div className="modal-body">
                                <div className="form-group">
                                    <label>Código <span className="text-danger">*</span></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={code}
                                        onChange={(e) => setCode(e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Porcentaje de Descuento <span className="text-danger">*</span></label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={discountPercentage}
                                        onChange={(e) => setDiscountPercentage(e.target.value)}
                                        min="0"
                                        max="100"
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Válido Desde <span className="text-danger">*</span></label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={validFrom}
                                        onChange={(e) => setValidFrom(e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Válido Hasta <span className="text-danger">*</span></label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        value={validUntil}
                                        onChange={(e) => setValidUntil(e.target.value)}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Usos Máximos <span className="text-danger">*</span></label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={maxUses}
                                        onChange={(e) => setMaxUses(e.target.value)}
                                        min="1"
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Estado</label>
                                    <select
                                        className="form-control"
                                        value={status}
                                        onChange={(e) => setStatus(parseInt(e.target.value))}
                                    >
                                        <option value={1}>Activo</option>
                                        <option value={0}>Inactivo</option>
                                    </select>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-success">
                                    <i className="fa-regular fa-floppy-disk me-1"></i>
                                    {discountCodeId === 0 ? "Guardar" : "Actualizar"}
                                </button>
                                <button
                                    id="closemodal"
                                    type="button"
                                    className="btn btn-danger"
                                    data-bs-dismiss="modal"
                                    onClick={clearFields}
                                >
                                    <i className="fa-solid fa-ban me-1"></i> Cancelar
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div className="content-wrapper">
                <ContentHeader title="Módulo de Códigos de Descuento" />
                
                <section className="content">
                    <div className="container-fluid">
                        <div className="card">
                            <div className="card-header">
                                <div className="d-flex justify-content-between align-items-center">
                                    <h3 className="card-title">
                                        <i className="fas fa-tags me-2"></i>
                                        Listado de Códigos de Descuento
                                    </h3>
                                    <button
                                        type="button"
                                        className="btn btn-success"
                                        data-bs-toggle="modal"
                                        data-bs-target="#modal-default"
                                        onClick={clearFields}
                                    >
                                        <i className="fa-solid fa-plus me-2"></i>
                                        Nuevo Código
                                    </button>
                                </div>
                            </div>
                            <div className="card-body table-responsive">
                                <table id="tableDiscountCodes" className="table table-hover text-nowrap">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Código</th>
                                            <th>Descuento</th>
                                            <th>Válido Desde</th>
                                            <th>Válido Hasta</th>
                                            <th>Usos Máx.</th>
                                            <th>Usos Act.</th>
                                            <th>Estado</th>
                                            <th>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {discountCodes.map((code) => (
                                            <tr key={code.discount_code_id}>
                                                <td>{code.discount_code_id}</td>
                                                <td>{code.code}</td>
                                                <td>{code.discount_percentage}%</td>
                                                <td>{formatDate(code.valid_from)}</td>
                                                <td>{formatDate(code.valid_until)}</td>
                                                <td>{code.max_uses}</td>
                                                <td>{code.current_uses}</td>
                                                <td>
                                                    <span className={`badge ${code.status === 1 ? 'bg-success' : 'bg-danger'}`}>
                                                        {code.status === 1 ? 'Activo' : 'Inactivo'}
                                                    </span>
                                                </td>
                                                <td>
                                                    <div className="btn-group">
                                                        <button
                                                            type="button"
                                                            className="btn btn-info btn-sm"
                                                            onClick={() => handleEdit(code)}
                                                            data-bs-toggle="modal"
                                                            data-bs-target="#modal-default"
                                                        >
                                                            <i className="fas fa-edit"></i>
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn btn-danger btn-sm"
                                                            onClick={() => handleDelete(code.discount_code_id)}
                                                        >
                                                            <i className="fas fa-trash"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default DiscountCodes;